/**
 * @generated SignedSource<<a561e9bf6456c20e33fe5a060501d08f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetBambooHRUserInput = {
  bambooHRUserId?: string | null;
  forecastPersonId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type SetBambooHRUserMutation$variables = {
  input: SetBambooHRUserInput;
};
export type SetBambooHRUserMutation$data = {
  readonly setBambooHRUser: {
    readonly viewer: {
      readonly bambooHRId: string | null;
    } | null;
    readonly person: {
      readonly bambooHRId: string | null;
    } | null;
  } | null;
};
export type SetBambooHRUserMutation = {
  variables: SetBambooHRUserMutation$variables;
  response: SetBambooHRUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bambooHRId",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetBambooHRUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetBambooHRUserPayload",
        "kind": "LinkedField",
        "name": "setBambooHRUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetBambooHRUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetBambooHRUserPayload",
        "kind": "LinkedField",
        "name": "setBambooHRUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a997ace557c59773c5c7854978a39dce",
    "id": null,
    "metadata": {},
    "name": "SetBambooHRUserMutation",
    "operationKind": "mutation",
    "text": "mutation SetBambooHRUserMutation(\n  $input: SetBambooHRUserInput!\n) {\n  setBambooHRUser(input: $input) {\n    viewer {\n      bambooHRId\n      id\n    }\n    person {\n      bambooHRId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1481fd7971167b52b1717ba89b309663";

export default node;
